const apiPaths = {
  AUTH: {
    STATUS: '/auth/account-status',
    LOGIN: '/auth/fo/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh-token',
    REGISTER_EMPLOYEE: '/auth/register/employee',
    REGISTER_MANAGER: '/auth/register/manager',
    REGISTER: '/auth/register',
    ASSIGN_QR: '/auth/assign-qr',
    CHECK_USER_QRS: '/auth/check-user-qr',
    SAVE_QR: '/auth/save-qr',
    UPDATE_USER_ROLE: '/auth/update-user-role',
    VALIDATE_TERMS: '/auth/accept-terms',
    VALIDATE_PROFILING: '/auth/profiling-newsletter',
    SEND_VALIDATION_EMAIL: '/auth/send-validation-email',
    VALIDATE_ACCOUNT: '/auth/validate-account',
    MANUALLY_VALIDATE_USER: '/auth/validate-user',
  },
  CALL: {
    ACTIONS_LIST: '/actions/app/list',
    ADD_JOURNEY: '/marketing-automation/register',
    CENTER_ACCEPT_REQUEST: '/userscenter/accept',
    CENTER_DECLINE_REQUEST: '/userscenter/decline',
    CENTER_REQUESTS: '/userscenter/list/requests',
    CENTER_USERS: '/center/usersList',
    COMPLETE_CHALLENGE_SURVEY: 'usersSurvey/challenge/complete',
    COMPLETE_SURVEY: 'usersSurvey/complete',
    CUSTOMER_CARE_MAIL: '/users/sendcustomercare',
    DELEGATE_MAIL: '/users/sendmaildelegate',
    EMBRACE_PRACTICE_BY_ID: '/center/embrace',
    EMBRACE_PRACTICES: '/center/embracecenters',
    LIWW_PRACTICES: '/center/liwwcenters',
    PARAMETERS: '/parameters',
    PLATFORM_STATUS: '/parameters/platform/status',
    COUNTRY_TAX: '/parameters/tax/taxCountry',
    PUBLIC_HOME: '/contentpage/user/public-home',
    PUBLIC_MENU: '/usersmenu/publicMenu',
    PUBLIC_STATIC_PAGES: '/contentpage/static/public',
    SPECIALTY_LIST: '/specialty/combo/list',
    SURVEY: '/survey/user',
    USA_PRACTICES: '/center/allcenters',
    USER_HOME: '/contentpage/user/home',
    USER_INFO: '/users/user/info',
    USER_MENU: '/usersmenu/byUser',
    USER_STATIC_PAGES: '/contentpage/static',
    USER_TEMPORAL_DATA: '/users/user/temporal-data',
  },
  CHALLENGES: {
    ATTEND_TO_EVENT: '/userResource/attend',
    COMPLETE_TRAINING: '/userResource/training',
    EVENT_ICS: '/resource/calendar',
    GET_CAMPAIGNS: '/challenge/campaigns/list',
    GET_CATEGORIES: '/challenge/categories',
    GET_CHALLENGE_BY_USER: '/challenge/user',
    GET_EVENTS: '/challenge/events/list',
    GET_EXPERIENCES: '/challenge/experiences/list',
    GET_CHALLENGES: '/challenge/challenges/list',
    GET_TAGS_EXPERIENCES: '/tag/experiences/list',
    GET_TAGS_CHALLENGES: '/tag/challenges/list',
    GET_DONATIONS: '/challenge/donations/list',
    GET_QUIZ_STATISTICS: '/challenge/report/training',
    GET_TRAININGS: '/challenge/trainings/list',
    GET_FORMATIONS: '/challenge/formations/list',
    GET_USER_CHALLENGE_BY_SLUG: '/challenge/user/slug',
    GET_USER_CHALLENGE: '/challenge/user',
    LIKES: '/likes',
    SUBSCRIBE_USER_WAITING_LIST: '/userResource/waitingList',
    SUBSCRIBE_USER: '/userResource/subscribe/event',
    UNSUBSCRIBE_USER: '/userResource/unsubscribeFo',
    COMPLETE_USER_RESOURCE: 'userResource/campaignResource',
    COMPLETE_SHOPPING_CART: 'userResource/shopping',
    COMPLETE_EXPERIENCE: 'userResource/experienceResource',
    COMPLETE_FORMATION: 'userResource/formationResource',
    COMPLETE_FORMATION_CON: 'userResource/formationResource',
    COMPLETE_DONATION: 'userResource/donationResource',
    COMPLETE_CHALLENGE: 'userResource/challengeResource',
    CHECKOUT: 'userResource/checkout',
    CHECKOUT_STATUS: '/checkout',
    CHECKOUT_PHARMACIES: '/pharmacy/checkout',
    REPLAY_CHALLENGE: '/userResource/replay',
    CREATE_CHECKOUT_PAYMENT: '/sells/new',
    PROCESS_CHECKOUT_PAYMENT: '/sells/payment',
    WAITING_CHECKOUT_PAYMENT: '/sells/waiting',
  },
  COMBO_IDS: {
    CATEGORIES: 'categories',
    CONTACT_CUSTOMER: 'contactCustomer',
    GENDER: 'gender',
    PHARMACIES: 'pharmacies',
    PREFIX_COUNTRIES: 'prefixCountries',
    QR_PRODUCTS: 'qrProducts',
    REGION_LIST: 'regionList',
    DEPARTMENT_LIST: 'departmentList',
    PROVINCE_LIST: 'provinceList',
    DISTRICT_LIST: 'districtList',
    SUBURB_LIST: 'suburbList',
    COMUNA_LIST: 'comunaList',
    EXPIRATION_PARAMS: 'expirationPointsParams',
  },
  COMBOS: '/comboData',
  COMBOS_PUBLIC: '/comboData/public',
  CUSTOMER_REQUEST_ORDER: '/requestquotation',
  MAGENTO: {
    COUNTRIES: '/magento/countries',
    GET_CART: '/magento/customer/cart',
    GET_CUSTOMER_INVOICE_DETAILS: '/magento/customer/invoiceDetails',
    GET_CUSTOMER_INVOICE: '/magento/customer/invoices',
    GET_CUSTOMER_ORDER_DETAILS: '/magento/customer/orderDetails',
    GET_CUSTOMER_ORDERS: '/magento/customer/orders',
    GET_CUSTOMER_POINTS_HISTORY: '/magento/customer/pointsHistory',
    GET_CUSTOMER_POINTS: '/magento/customer/points',
    GET_CUSTOMER_REORDER: '/magento/customer/reorder',
    GET_CUSTOMER_REQUEST_ORDER: '/magento/products/quotationProducts',
    GET_ISDIN_BRANDS: '/magento/products/brands',
    ISDIN_ADDRESS: '/magento/customer/address',
  },
  MARKETING_MATERIALS: {
    ALL: '/marketingmaterials/materials/all',
  },
  NEWSLETTER: {
    SUBSCRIBE: '/mailchimp/subscribe',
    UNSUBSCRIBE: '/mailchimp/unsubscribe',
  },
  MC_NEWSLETTER: {
    SUBSCRIBE: '/marketing-api/subscribe',
    UNSUBSCRIBE: '/marketing-api/unsubscribe',
    SUBSCRIBE_PREGNANCY: '/marketing-api/subscribePregnancy',
    INFO: '/marketing-api/email',
  },
  PHARMACY: {
    GET_PHARMACY: '/pharmacy/sap', // /:sapCustomerId
  },
  PROFILE: {
    COMPLETE_PROFILE: '/users/complete-profile',
    UPDATE_USER_INFO: '/users/fo',
    UPDATE_USER_BANNER_STATUS: 'users/temporaldata-banner',
    UPDATE_USER_DERMO_ONBOARDING: '/users/dermo-onboarding',
    UPDATE_USER_PHARMACY: '/users/pharmacy',
    DELETE_USER_PHARMACY: '/users/delete-pharmacy',
    UPDATE_USER_PASSWORD: '/users/changepassword',
    USER_ADDRESS: '/user/address',
    USER_TERMS_COND: 'users/terms-cond',
  },
  RECOVERY_PASSWORD: '/recoveryPassword/liww',
  RESET_PASSWORD: '/recoveryPassword/changepassword/liww',
  RECOVERY_PASSWORD_USERINFO: '/recoveryPassword/userInfo/liww',
  TRAINING_MATERIALS: 'marketingMaterials/training', // /:idChallenge
  UPLOAD_IMAGE: 'upload/image',
  POINTS_API: {
    GET_CUSTOMER_POINTS: '/points/customer/points',
    GET_CUSTOMER_POINTS_HISTORY: '/points/customer/pointsHistory',
    GET_CUSTOMER_TRANSACTIONS: '/points/customer/transactions',
    GET_EXPIRATION_POINTS: '/points/expiration',
  },
  QR_BRIDGE: {
    GET_QR_INFO: '/qr/info',
  },
  QR_PRODUCTS: {
    GET_DETAIL: '/qrProduct/detail/product',
  },
  DERMO: {
    GET_DERMO_DATA: '/dermoCenterRegionPos',
    GET_DERMO_USER_POS: '/dermoUserPos',
    REGISTER_DERMO: '/dermoUserPos',
    DERMO_SOFT_DELETE: '/userRoles', // /:idUserRole
    USER_ROLES: '/userRoles',
    GET_DERMO_USER_ROLE: '/getUserRoleDermo',
    SET_DERMO_USER_STATUS: '/setUserStatus',
  },
  CONSUMABLES: {
    CONSUME_BONUS: '/bonus/consume',
    GET_ALL_CUSTOMER_COUPONS: '/my-bonus',
    GET_PRODUCT_LANDING: '/get-product-landing',
    SCAN_QR: '/bonus/scan-qr',
    PREVIEW_SCAN_QR: '/bonus/preview-scan-qr',
    GET_QR_LANDING_QR_PRODUCT: '/qr-landing/get-qr-product',
    JOIN_CAMPAIGN: '/campaigns/join-campaign',
    GET_ACTIVE_CAMPAIGNS: '/campaigns/get-active-campaign',
    PREVIEW_DISCOVERY_CAMPAIGN: '/campaigns/preview-discovery-campaign',
  },
  PREVIEW_EMAIL: '/mailTemplates/preview',
  PREGNANCY: {
    ASSIGN_PREGNANCY_ROLE: '/userRoles/assign-pregnancy-role',
  },
};

export default apiPaths;
